import React from 'react';

const Dropdown = React.forwardRef(({ name, text, values, placeholder, register}, ref) => {

    return (
        <>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2"
                htmlFor={name}>
                {text}
            </label>
            <select className='w-full text-sm bg-gray-50 dark:bg-gray-600 text-gray-900 dark:text-white border-2 border-gray-300 dark:border-gray-500 rounded-lg py-2 px-3 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 focus:bg-white dark:focus:bg-gray-700 transition-all duration-200 shadow-sm hover:shadow-md focus:shadow-lg' placeholder='Select here..' ref={ref} {...register(name)}>
                {
                    values.map(s => {
                        return <option key={s} value={s}>{s}</option>
                    })
                }
             </select>
        </>
    )
})

export default Dropdown;